import React from "react";
import { init } from "@noriginmedia/norigin-spatial-navigation";
// Using new MnbPlayer - custom player built from scratch
import PlayerContent from "../../player/PlayerContent";
import "../../player/styles/player.css";

init({
  debug: false,
  visualDebug: false,
});

export default function SpitialPlyer({ data }) {
  return (
    <div className="legacy-player-shell">
      <PlayerContent data={data} />
    </div>
  );
}
